//* global fetch */
import { h, Component } from 'preact'
import ReactTooltip from 'react-tooltip'
// import { route } from 'preact-router'
import Sizer from '../../components/atoms/sizer'
import Spinner from '../../components/atoms/spinner'
import loadData, { getType } from '../../data/index.mjs'
import { pageSupport } from '../../calculateSupport'
import fetcher from '../../utils/fetcher'

import PoliticianHead from './politician-head'
import PoliticianSection from './politician-section'
import PoliticianStatement from './politician-statement'
import PoliticianIsMOP from './politician-is-mop'

/* eslint-disable react/no-unused-state */

/* global window */

export default class Home extends Component {
  state = { data: false, downloading: false, votepoints: null, options: null }

  load = () => {
    loadData()
      .then(vp =>
        this.setState({
          votepoints: vp.votepoints,
          options: vp.options,
        }),
      )
      .catch(e => console.error(e))
  }

  render({ matches }, { data, downloading }) {
    if (!data && !downloading && typeof window !== 'undefined') {
      this.setState({ downloading: true })
      if (getType() === 'president' && matches.page === '6') {
        this.setState({
          data: {
            name: 'Jiří',
            surname: 'Hynek',
            notes:
              '"Kandidát na prezidenta Jiří Hynek se rozhodl této ankety neúčastnit. Chce i nadále komunikovat se svými příznivci přímo, nikoli prostřednictvím veřejných deklarací organizovaných třetími stranami."',
            signature: 'Jana Malíková, ředitelka komunikace',
            votes: [],
          },
        })
        this.load()
      } else if (getType() === 'president' && matches.page === '9') {
        this.setState({
          data: {
            name: 'Miloš',
            surname: 'Zeman',
            notes:
              '"Předvolebních dotazníkových šetření se v zásadě neúčastníme."',
            signature: 'Jiří Ovčáček, tiskový mluvčí prezidenta republiky',
            votes: [],
          },
        })
        this.load()
      } else if (getType() === 'president' && matches.page === '2') {
        this.setState({
          data: {
            name: 'Jiří',
            surname: 'Drahoš',
            html: `"Vážení, 
seznámil jsem s Vašimi dotazy a musím konstatovat, že v podobě, v jaké jsou položeny, na ně dost dobře nemohu odpovědět, a to ani jednou z možností, které u dotazů uvádíte (tedy VETOVAL/NEVETOVAL/NEJSEM ROZHODNUT). Důvodem je skutečnost, že prezidentské veto je v mém chápání velmi silný nástroj, který by měl být používán skutečně pouze ve výjimečných případech. Zpravidla v situaci, kdy prezident na základě podrobného odborného zkoumání dospěje k názoru, že dotyčný zákon porušuje některé principy právního státu, jako například právní jistoty, jiné zákony či pravidla, případně zavádí nejasná, neproveditelná pravidla, případně jeho schválení porušilo obecné principy tvorby práva atd. Nepředpokládám tedy, že bych veto používal z důvodu nesouhlasu s věcným obsahem zákona (snad s výjimkou případů, kdy by zákon nějak významněji vedl ke koncentraci moci či vážně narušoval některá podstatná pravidla rovnosti práv, spravedlnosti, přiměřenosti apod.).
Snad je z tohoto stručného výkladu zřejmé, že bez podrobnějšího seznámení s celým návrhem zákona, bez konzultace s odborníky a bez znalosti legislativního procesu nelze dost dobře takto „od boku vystřelit“ nějaký kvalifikovaný verdikt. Zároveň je také zřejmé, že institut veta bych nepoužíval v případě, že by se mi některá ustanovení pouze jaksi „nezdála“ věcně správná. Což je snad alespoň částečná věcná odpověď na Vaše dotazy. 
<br> 
Zbývá dodat, že osobně jsem zastáncem transparentnosti státní správy i územní samosprávy a tudíž i práva na informace o činnosti orgánů veřejné správy. Pokud jde o konkrétní pravidla, viz moje výše uvedené argumenty. Mám za to, že k řadě podstatných okolností v této oblasti se již vyslovil i Ústavní soud.
<br>
Velice Vám děkuji za zájem o moje názory a jsem s pozdravem"`,
            signature: 'Jiří Drahoš',
            votes: [],
          },
        })
        this.load()
      } else {
        fetcher({
          path: `/api/votes/${matches.page}`,
          onData: v => {
            this.setState({ data: v })
            this.load()
          },
        })
      }
    }
    setTimeout(() => ReactTooltip.rebuild(), 0)
    const { votepoints, options } = this.state

    const pointsAtIdx = i => {
      const p = votepoints[i]
      if (p.points.length === data.votes[i].length) return p.points
      if (!p.altpoints) return p.points
      return p.altpoints
    }
    return (
      <Sizer>
        {!data || !votepoints ? (
          <Spinner />
        ) : (
          <div>
            <PoliticianHead
              name={data.name}
              surname={data.surname}
              party={data.party}
            />
            <PoliticianIsMOP
              id={matches.page}
              value={data.is_in_parliament}
              onChange={value =>
                this.setState({
                  data: {
                    ...data,
                    is_in_parliament: value,
                  },
                })
              }
            />
            <PoliticianStatement
              notes={data.notes}
              signature={data.signature}
              html={data.html}
            />

            {data.votes.map((votes, i) => (
              <PoliticianSection
                votepoint={votepoints[i]}
                percent={
                  votes
                    .map(
                      v =>
                        this.state.options.find(opt => `${opt.id}` === `${v}`)
                          .score,
                    )
                    .reduce((a, b) => a + b, 0) / votes.length
                }
                points={pointsAtIdx(i)}
                votes={votes}
                options={options}
              />
            ))}
          </div>
        )}
      </Sizer>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician.js